import React, { useState } from "react"
import { observer } from "mobx-react-lite"
import { Pressable } from "~/ui/primitives"
import styled, { useTheme } from "~/ui/styled"
import { Flex, ColumnFlex, CenterFlex, BetweenFlex, Text, IconFont, Hr } from "~components/El"
import Select from "../components/Select"
import { NotDisturbModeScreenProps } from "./types"
import SlideInput from "~components/slider-input"
import { alertError } from "~utils/alert"

const Container = styled.View`
  flex-direction: column;
  flex: 1;
  padding: 0 12px;
`

const columns = [
  { label: "默认", desc: "系统默认", value: "1m" },
  { label: "叮咚", desc: "清脆的叮咚声", value: "2m" },
  { label: "风铃", desc: "轻柔的风铃声", value: "3m" },
  { label: "铃铛", desc: "清亮的铃铛声", value: "4m" },
  { label: "泡泡", desc: "轻快的泡泡声", value: "5m" },
  { label: "口哨", desc: "间断的口哨声", value: "6m" },
  { label: "无声音", desc: "不播放任何声音", value: "7m" },
]

const NotificationBell: React.FC<NotDisturbModeScreenProps> = ({ route }) => {
  const theme = useTheme()
  const [preset, setPreset] = useState("")
  const LabelComponent = ({ item, active }) => {
    const handlePlay = (item) => {
      // console.log(item)
      alertError({ message: "播放铃声功能待开发" })
    }
    return (
      <BetweenFlex flex={9} style={{ paddingRight: 8 }}>
        <ColumnFlex>
          <Text>{item.label}</Text>
          <Text fontSize="12" color={theme.colors.infoText} mt="6">
            {item.desc || "暂无描述"}
          </Text>
        </ColumnFlex>
        <Pressable onClick={() => handlePlay(item)}>
          <CenterFlex
            style={{
              width: 36,
              height: 36,
              borderRadius: 18,
              backgroundColor: active ? theme.colors.primary + "22" : theme.colors.infoText + "22",
            }}
          >
            <IconFont
              name="bf"
              size={16}
              color={active ? theme.colors.primary : theme.colors.infoText}
            />
          </CenterFlex>
        </Pressable>
      </BetweenFlex>
    )
  }
  return (
    <Container>
      {/* <Flex
                flexDirection="column"
                width="100%"
                mt="10px"
                padding="10px 12px"
                borderRadius="8px"
                bg={theme.colors.blockBackground}
            >
                <Text color={theme.colors.text} fontSize={theme.fontSizes.md} fontWeight="600">
                <IconFont name="jilu" size={12} color={theme.colors.purpleBackground} />&nbsp;&nbsp;选择通知铃声
                </Text>
                <Flex
                    flexDirection="column"
                    width="100%"
                    mt="10px"
                >
                    <StartFlex>
                        <Text color={theme.colors.secondaryText} fontSize={theme.fontSizes.md} lineHeight="22px">
                            点击试听,选择您喜欢的通知铃声
                        </Text>
                    </StartFlex>
                </Flex>
            </Flex> */}
      <ColumnFlex
        width="100%"
        mt="10px"
        padding="0 12px"
        borderRadius="8px"
        bg={theme.colors.blockBackground}
      >
        <Select
          title="选择通知铃声"
          titleIcon="tzls"
          description="点击试听,选择您喜欢的通知铃声"
          LabelComponent={LabelComponent}
          options={columns}
          value={preset}
          onChange={(val) => {
            setPreset(val)
          }}
        />
      </ColumnFlex>
      <Flex
        flexDirection="column"
        width="100%"
        mt="10px"
        padding="10px 12px"
        borderRadius="8px"
        bg={theme.colors.blockBackground}
      >
        <Text
          //   color={theme.colors.primaryText}
          fontSize={theme.fontSizes.md}
          //   fontWeight="600"
          lineHeight="40px"
        >
          音量设置
        </Text>
        <Hr />
        <BetweenFlex width="100%" mt="10px">
          <IconFont name="sytz" size={20} color={theme.colors.text} />
          <SlideInput step={1} value={70} onChange={(v) => {}} />
        </BetweenFlex>
      </Flex>
    </Container>
  )
}

export default observer(NotificationBell)
